<template>
  <div class="container">
    <div class="space-100"></div>
    <div class="row first-secction">
      <div class="col-sm-6">
        <h2>70% de los ingresos de una empresa provienen de clientes frecuentes</h2>
        <p class="txt-how-we-are">¿Sabes quienes son? ¿Sabes si regresan? ¿Qué estás haciendo para mantenerlos contentos?
        <br><br>
        <strong>Loyalty Refunds</strong> genera recurrencia en ventas de manera medible al alcance de cualquier empresa.
        </p>
      </div>
      <div class="col-sm-6">
        <img class="first-img" src="../assets/assets_loyalty/assets-17.png">
      </div> 
    </div>
    <!-- INICIA SEGUNDA SECCION -->
    <div class="space-70"></div>
    <div class="row first-secction">        
      <div class="col-sm-6">
        <img class="second-img" src="../assets/assets_loyalty/assets-16.png">
      </div>
      <div class="col-sm-6">
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png">Genera <strong>Monederos Electrónicos</strong> a tu medida en minutos.</p>
        </ul>
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png">Personaliza tus promociones y <strong>MIDE LOS RESULTADOS.</strong></p>
        </ul>
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png"><strong>INCREMENTA</strong> tus ventas premiando a tus clientes con puntos para que regresen.</p>
        </ul>
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png">Modulo de inteligencia de negocios para mejorar la toma de decisión.</p>
        </ul>
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png">Funciona con o sin integración a tu punto de venta.</p>
        </ul>
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png">Planes mensuales y anuales.</p>
        </ul>
        <ul class="list-contemt">
          <p><img class="icon-second-secction" src="../assets/assets_loyalty/asset-34.png">Consultoría en estrategias y operación del programa.</p>
        </ul>
      </div> 
    </div>
    <!-- INICIA TERCERA SECCION -->
    <div class="space-50"></div>
    <div class="row justify-content-center">
      <div class="text-center">
        <h2><strong>Precios sencillos y transparentes</strong></h2>
        <p>Siempre sabrás lo que vas a pagar.</p>
      </div>
    </div>
    <div class="space-50"></div>
      <div class="row">
        <div class="col-sm-6">
          <div class="box text-center">
            <h2>Cámbiate a Pro</h2>
            <div class="row">
              <div class="mounth-text">Mensual</div>
              <div class="switch-style"><switches v-model="enabled"></switches></div>
              <div class="year-text">Anual</div>
            </div>
              <br>
              <div v-if="!enabled"><h2 class="cifra"><strong>$4,000.00</strong></h2></div>
              <div v-if="enabled"><h2 class="cifra"><strong>$40,000.00</strong></h2></div>
              <p><strong>¡Inicia ya!</strong></p>
              <br>
              <p><strong>Configura tu sistema en minutos y <br> aumenta el valor de tu negocio.</strong></p>
              <br>
              <div>
                <n-button @click="modals.classic2 = true" class="want-button" type="primary" round><strong>Lo quiero <i style="margin-left:10px; font-size:20px" class='fas fa-arrow-right'></i></strong></n-button>
              </div>
          </div>
        </div> 
        <div class="col-sm-6">
          <div class="third-section-right">
            <ul class="responsive-ul"><img class="check-icon" src="../assets/assets_loyalty/loyalty website-35.png">Transacciones mensuales <strong>ilimitadas</strong></ul>
            <ul class="responsive-ul"><img class="check-icon" src="../assets/assets_loyalty/loyalty website-35.png">Usuarios <strong>ilimitados</strong></ul>
            <ul class="responsive-ul"><img class="check-icon" src="../assets/assets_loyalty/loyalty website-35.png">Alta de cuentas de clientes <strong>ilimitadas</strong></ul>
            <ul class="responsive-ul"><img class="check-icon" src="../assets/assets_loyalty/loyalty website-35.png">Reportes <strong>ilimitados</strong></ul>
            <ul class="responsive-ul"><img class="check-icon" src="../assets/assets_loyalty/loyalty website-35.png">Promociones <strong>ilimitadas</strong></ul>
          </div>
        </div> 
      </div>
    <!-- INICIA TERCERA SECCION -->
      <div class="space-100"></div>
      <div class="row">
        <h2 class="section-title"><strong>Disfruta también de:</strong></h2>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row text-center">
            <div class="col-sm-2">
              <img class="icons-section" src="../assets/assets_loyalty/loyalty website-36.png"><br>
              <p>Genera encuestas <br> ilimitadas</p>
            </div>
            <div class="col-sm-2">
              <img class="icon-hand" src="../assets/assets_loyalty/loyalty website-39.png"><br>
              <p>Agrega o <br> resta puntos <br> desde el <br> administrador</p>
            </div>
            <div class="col-sm-2">
              <img class="icons-section" src="../assets/assets_loyalty/loyalty website-40.png"><br>
              <p>Cupones <br> mensuales <br> ilimitados</p>
            </div>
            <div class="col-sm-2">
              <img class="icons-section" src="../assets/assets_loyalty/loyalty website-37.png"><br>
              <p>2500 Emails <br> mensuales por sucursal</p>
            </div>
            <div class="col-sm-2">
              <img class="icons-section" src="../assets/assets_loyalty/loyalty website-38.png"><br>
              <p>Cuentas <br> referenciables</p>
            </div>
            <div class="col-sm-2">
              <img class="icons-section" src="../assets/assets_loyalty/loyalty website-41.png"><br>
              <p>Programas <br> Multinivel</p>
            </div>
          </div>
          <div class="space-50"></div>
          <div class="row text-center">
          </div>
        </div> 
      </div>
    <!-- INICIA CUARTA SECCION -->
      <div class="space-50"></div>
      <div class="row row-style">
        <div class="col-sm-6">
          <div class="left-content-blue-secction">
            <h2 class="title-blue-section"><strong>Agenda una prueba gratuita</strong></h2>
          </div>
        </div>
        <div class="col-sm-6 text-center">
          <div class="right-content-blue-secction">
            <h2><strong>Conversemos</strong></h2>
            <button  @click="modals.classic2 = true" class="quote-button">Solicitar cotización</button>
            <modal class="resposive-modal" :show-close="true" :show.sync="modals.classic2" modal-classes="modal-lg" header-classes="justify-content-center">
              <h4 slot="header" class="title title-up text-color-blue text-center"><strong>Contactanos</strong></h4>
              <contact-modal></contact-modal>
            </modal>
          </div>
        </div> 
      </div>
    <!-- INICIA QUINTA SECCION -->
      <div class="space-50"></div>
      <div class="row">
        <div class="col-sm-10">
          <div class="row system-section">
            <div class="system-logo-area">
              <img class="icon-section" src="../assets/assets_loyalty/loyalty website-42.png">
            </div>
            <div class="system-txt-area">
              <h4 class="system-title"><strong>Estrategias Personalizadas</strong></h4>
            </div>
          </div>
          <div class="row row-p">
            <p class="txt-in-last-secction">Somos especialistas en el desarrolo de sistemas de lealtad, monederos electrónicos, programas de incentivos y pagos, contamos con diferentes esquemas de comercialización.</p>
          </div>
          <div class="space-50"></div>
          <div class="row whant-section">
            <div class="system-logo-area">
              <img class="icon-section" src="../assets/assets_loyalty/loyalty website-43.png">
            </div>
            <div class="system-txt-area">
              <h4 class="whant-title"><strong>Quiero ser distribuidor</strong></h4>
            </div>
          </div>
          <div class="row row-p">
            <p class="txt-in-last-secction">Emprende un gran negocio con nosotros, ofrecemos excelentes comisiones y atractivos esquemas.</p>
          </div>
          <div class="space-50"></div>
          <div class="row whant-section">
            <div class="system-logo-area">
              <img class="icon-section" src="../assets/assets_loyalty/loyalty website-44.png">
            </div>
            <div class="system-txt-area">
              <h4 class="without-title"><strong>Sin riesgos y fácil de usar</strong></h4>
            </div>
          </div>
          <div class="row row-p">
            <p class="txt-in-last-secction">En loyalty Refunds estamos seguros de que nuestro sistema te funcionará y si en seis meses no empiezas a ver resultados, ¡Te regresamos tu dinero! </p>
          </div>
        </div>
      </div>
      <!-- INICIA SEXTA SECCION -->
      <div class="space-50"></div>
      <div class="row last-secction-responsive">
        <div class="col-sm-6 h2-resposive">
          <h2 style="color:#00B9FF;">¿Listo para comenzar?</h2>
          <h2>Contacta con nostros o crea directamente tu cuenta.</h2>
        </div>
        <div class="col-sm-5">
          <br>
          <div class="row justify-content-center">
            <button class="create-buttom" @click="modals.classic = true">Crear cuenta <i class="fa fa-arrow-right" style="font-size:24px;"></i></button>
          </div>
          <modal :show-close="true" :show.sync="modals.classic" modal-classes="modal-lg" header-classes="justify-content-center">
            <h4 slot="header" class="title title-up text-color-blue text-center"><strong>Registra tu cuenta Loyalty Refunds freemium</strong></h4>
            <suscribe-modal></suscribe-modal>
          </modal>
          <br>
          <div class="row justify-content-center">
            <button @click="modals.classic2 = true" class="contact-buttom">Contacta con nuestro equipo</button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button, Modal } from '@/components';
import Switches from 'vue-switches';
import SuscribeModal from './components/SuscribeModal'
import ContactModal from './components/ContactModal'


export default {
  components: {
    ContactModal,
    Card,
    Switches,
    Modal,
    SuscribeModal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data(){
    return {
      modals: {
        classic: false,
        classic2: false,
      },
      nameVerified: '',
      emailVerified: '',
      numberVerified: '',
      messageVerified: '',
      enabled: false
    }
  },
  mounted(){
    this.showPrice()
  },
  methods:{
    showPrice(){
    }
  }
}
</script>
<style>
.background-color{
    background-color: #0069A9;
}
.text-color{
  color: white;
}
.txt-how-we-are{
  text-align: justify;
}
.input-section{
  width: 230px;
  padding: 8px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
}
.textarea-section{
  padding: 10px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
}
.captcha{
  width: 100%;
  height: 50px;
}
.send-button{
  width: 100%;
  height: 50px; 
}
.first-img{
  width: 80%;
  margin: 50px 0px 0px 60px;
}
.second-img{
  width: 70%;
  margin: 20px 0px 0px 60px;
}
.icon-second-secction{
  margin: 0px 15px 3px 0px;
  width: 30px;
}
.box{
  padding: 20px;
  width: 500px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 3px solid #ededed
}
.switch-style{
  margin-top: 8px;
  margin-left: 8px;
  background-color:black;
}
.cifra{
  font-size: 70px;
}
.want-button{
  width: 200px;
}
.check-icon{
  width: 35px;
  margin: 25px 10px 25px 10px;
}
.section-title{
  font-size: 20px;
}
.icons-section{
  width: 70px;
  margin: 20px;
}
.icon-hand{
  width: 50px;
  margin: 15px;
}
.row-style{
  background-color: #0069A9;
  height: 225px;
}
.left-content-blue-secction{
  color:white;
  text-align: center;
  margin-top: 90px;
}
.title-blue-section{
  font-size: 25px;
}

.right-content-blue-secction{
  color:white;
  padding: 50px; 
  font-size: 20px;
}
.quote-button{
  width: 200px;
  padding:10px;
  font-size: 15px;
  font-weight: bold;
  color: #7F7F7F;
  border-radius: 19px 19px 19px 19px;
  -moz-border-radius: 19px 19px 19px 19px;
  -webkit-border-radius: 19px 19px 19px 19px;
  border: 0px solid #ffffff;
  background-color: #ffffff;
}
.icon-section{
  width: 100%;
  padding: 15px;
  margin-right: 10px;
}

.system-title{
  color:#00B9FF;
  margin-top: 35px;
}

.whant-title{
  color:#00B9FF;
  margin-top: 55px;
}

.without-title{
  color:#00B9FF;
  margin-top: 45px;
}
.row-p{
  padding-left: 103px;
  font-size: 17px;
}
.create-buttom{
  width: 250px;
  padding:10px;
  font-size: 20px;
  font-weight: bold;
  color: white;
  border-radius: 19px 19px 19px 19px;
  -moz-border-radius: 19px 19px 19px 19px;
  -webkit-border-radius: 19px 19px 19px 19px;
  border: 1px solid #ffffff;
  background-color: #ff7b00;
}
.contact-buttom{
  width: 350px;
  padding:10px;
  font-size: 18px;
  font-weight: bold;
  color: #7F7F7F;
  border-radius: 19px 19px 19px 19px;
  -moz-border-radius: 19px 19px 19px 19px;
  -webkit-border-radius: 19px 19px 19px 19px;
  border: 0px solid #ffffff;
  background-color: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(173,173,173,1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(173,173,173,1);
  box-shadow: 0px 3px 5px 0px rgba(173,173,173,1);
  }
.list-contemt{
  margin-bottom: 30px;
}
.third-section-right{
  font-size: 18px;
}

.mounth-text{
  margin-top: -4px;
  margin-left: 150px;
}

.switch-style{
  margin: 0px 20px 0px 20px;
  background-color: #ffffff;
}
.year-text{
  margin-top: -4px;
}

.system-logo-area{
  width: 10%;
}
.system-txt-area{
  width: 90%;
}

@media screen and (min-width: 321px) and (max-width: 768px) { 
  .system-logo-area{
    width: 100%;
    text-align: center;
  }
  .system-title{
    margin: 0;
    font-size: 20px;
  }
  .txt-in-last-secction{
    text-align: justify;
    padding: 10px;
  }
  .whant-title{
    margin: 0;
    font-size: 20px;
  }
  .without-title{
    margin: 0;
    font-size: 20px;
  }
  .system-txt-area{
    width: 100%;
    text-align: center;
  }
  .txt-how-we-are{
    text-align: center;
  }
  .contact-buttom{
    margin-bottom: 50px;
  }
  .first-secction{
    text-align: center;
  }
  .first-img{
    width: 80%;
    margin: 0px;
  }
  .second-img{
    width: 70%;
    margin: 0px;
  }
  .list-contemt{
    margin-left: -35px;
    margin-top: 10px;
    text-align: justify;
    margin-bottom: 30px;
  }
  .box{
    padding: 20px;
    width: 100%;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 3px solid #ededed;
    margin-bottom: 50px;
  } 
  .mounth-text{
    margin-top: -4px;
    margin-left: 80px;
  }
  .cifra{
    font-size: 50px;
  }

  .responsive-ul{
    margin-left: -35px;
    line-height : 0px;
    font-size: 15px;
  }

  .check-icon{
    width: 35px;
    margin: 0px;
  }

  .section-title{
    margin-left: 20px;
  }
  .row-style{
    background-color: #0069A9;
    height: 500px;
  }

  .left-content-blue-secction{
    color:white;
    padding: 10px;
    padding-top: 50px; 
  }
  .title-blue-section{
    font-size: 25px;
  }

  .right-content-blue-secction{
    color:white;
    padding: 0px; 
    font-size: 15px;
  }

  .icon-section {
    width: 20%;
    padding: 15px;
  }
  .row-p {
    padding-left: 20px;
    font-size: 15px;
  }
  .h2-resposive{
    font-size: 12px;
  }

  .last-secction-responsive{
    margin-top: 50px;
  }
  .modal-content{
    margin: 0px;
  }
}
</style>
